module.exports = __webpack_public_path__ + "static/img/check.1e2d05e5.png";